import request from '@/utils/request';
export function login(data) {
  return request({
    url: '/auth/token/login/',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/auth/users/me/',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function getInfoDetail(id, token) {
  return request({
    url: '/auth/users/me/',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: '/auth/token/logout',
    method: 'post'
  });
}
export function sendSmsCode(data) {
  return request({
    url: '/common/sms/send_code/',
    method: 'post',
    data: data
  });
}
export function loginByPhone(data) {
  return request({
    url: '/common/login/',
    method: 'post',
    data: data
  });
}
export function getCommonConfig(data) {
  return request({
    url: '/common/common_config/',
    method: 'get',
    params: data
  });
}

// 邮箱相关接口 - 海外环境使用
export function sendEmailCode(data) {
  return request({
    url: '/common/email/send_code/',
    method: 'post',
    data: data
  });
}
export function loginByEmail(data) {
  return request({
    url: '/common/email_login/',
    method: 'post',
    data: data
  });
}